import { setupSentry } from "./sentry.config";

setupSentry();
